export default "__VITE_ASSET__BBB_GSit__"